import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './styles/Home.css';

function Home() {
    const [topAssets, setTopAssets] = useState([]);
    const [inView, setInView] = useState(false);
    const sectionRef = useRef(null);

    useEffect(() => {
        const fetchTopAssets = async () => {
            // Mock data. Replace with real API data fetching
            const data = [
                { platform: 'Binance', topAsset: 'Bitcoin (BTC)' },
                { platform: 'Coinbase', topAsset: 'Ethereum (ETH)' },
                { platform: 'Robinhood', topAsset: 'Apple Inc. (AAPL)' },
                { platform: 'E*TRADE', topAsset: 'Microsoft Corp (MSFT)' },
                { platform: 'TD Ameritrade', topAsset: 'Amazon.com Inc. (AMZN)' },
                { platform: 'Kraken', topAsset: 'Cardano (ADA)' },
                { platform: 'Fidelity', topAsset: 'Tesla Inc. (TSLA)' },
                { platform: 'WeBull', topAsset: 'NVIDIA Corp (NVDA)' },
                { platform: 'Bitfinex', topAsset: 'Polkadot (DOT)' },
                { platform: 'Huobi', topAsset: 'Chainlink (LINK)' }
            ];
            setTopAssets(data);
        };

        fetchTopAssets();
    }, []);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setInView(true);
                    observer.unobserve(entry.target);
                }
            },
            { threshold: 0.1 }
        );
    
        const currentSection = sectionRef.current; // Capture the current ref value
        if (currentSection) {
            observer.observe(currentSection);
        }
    
        return () => {
            if (currentSection) {
                observer.unobserve(currentSection);
            }
        };
    }, []);
    

    const platforms = [
        { 
            name: 'Binance', 
            website: 'https://www.binance.com/', 
            reason: 'Binance is one of the largest cryptocurrency exchanges globally, known for its extensive selection of cryptocurrencies, high liquidity, and competitive trading fees. It offers advanced trading features such as futures and margin trading, alongside a comprehensive suite of tools for both beginners and experienced traders.',
            topAsset: topAssets.find(asset => asset.platform === 'Binance') 
        },
        { 
            name: 'Coinbase', 
            website: 'https://www.coinbase.com/', 
            reason: 'Coinbase is a widely recognized cryptocurrency exchange with a user-friendly interface and robust security features. It provides a seamless experience for buying, selling, and storing cryptocurrencies, supported by strong educational resources to help new users get started.',
            topAsset: topAssets.find(asset => asset.platform === 'Coinbase') 
        },
        { 
            name: 'Robinhood', 
            website: 'https://www.robinhood.com/', 
            reason: 'Robinhood revolutionized stock trading by offering commission-free trades for stocks, ETFs, and cryptocurrencies. Its intuitive app design and real-time market data make it a popular choice for casual and new investors seeking a straightforward trading experience.',
            topAsset: topAssets.find(asset => asset.platform === 'Robinhood') 
        },
        { 
            name: 'E*TRADE', 
            website: 'https://www.etrade.com/', 
            reason: 'E*TRADE provides a comprehensive trading experience with access to a broad range of investment options including stocks, ETFs, options, and mutual funds. It features powerful trading tools, extensive research resources, and educational materials suited for both novice and seasoned investors.',
            topAsset: topAssets.find(asset => asset.platform === 'E*TRADE') 
        },
        { 
            name: 'TD Ameritrade', 
            website: 'https://www.tdameritrade.com/', 
            reason: 'TD Ameritrade is renowned for its extensive research tools, educational resources, and advanced trading platform. With a focus on active traders, it offers features like thinkorswim® trading platform, which provides advanced charting, analytics, and trading functionalities.',
            topAsset: topAssets.find(asset => asset.platform === 'TD Ameritrade') 
        },
        { 
            name: 'Kraken', 
            website: 'https://www.kraken.com/', 
            reason: 'Kraken is known for its strong security measures and wide range of supported cryptocurrencies. It offers advanced trading options such as futures and margin trading, making it a preferred choice for experienced crypto traders and investors.',
            topAsset: topAssets.find(asset => asset.platform === 'Kraken') 
        },
        { 
            name: 'Fidelity', 
            website: 'https://www.fidelity.com/', 
            reason: 'Fidelity is a leading investment firm providing a broad array of investment products, including stocks, bonds, ETFs, and mutual funds. It is well-regarded for its research tools, retirement planning resources, and exceptional customer service.',
            topAsset: topAssets.find(asset => asset.platform === 'Fidelity') 
        },
        { 
            name: 'WeBull', 
            website: 'https://www.webull.com/', 
            reason: 'WeBull offers commission-free trading with advanced charting tools, real-time market data, and a customizable trading experience. It caters to traders looking for a feature-rich platform with extensive analysis tools and a high level of market transparency.',
            topAsset: topAssets.find(asset => asset.platform === 'WeBull') 
        },
        { 
            name: 'Bitfinex', 
            website: 'https://www.bitfinex.com/', 
            reason: 'Bitfinex provides a robust trading platform known for its high liquidity and advanced trading features. It supports a wide range of cryptocurrencies and offers features such as margin trading and lending, catering to professional and institutional traders.',
            topAsset: topAssets.find(asset => asset.platform === 'Bitfinex') 
        },
        { 
            name: 'Huobi', 
            website: 'https://www.huobi.com/', 
            reason: 'Huobi is a global cryptocurrency exchange offering a comprehensive trading platform with a wide range of digital assets. It features advanced trading tools, high liquidity, and a strong security framework, making it a popular choice among serious crypto traders.',
            topAsset: topAssets.find(asset => asset.platform === 'Huobi') 
        }
    ];

    return (
        <div style={{ fontFamily: 'Arial, sans-serif', padding: '20px', backgroundColor: '#121212', color: '#e0e0e0' }}>
            <header style={{ textAlign: 'center', marginBottom: '20px', backgroundColor: '#1e1e1e', padding: '20px', borderRadius: '8px' }}>
                <h1 style={{ fontSize: '2.5em', color: '#e0e0e0' }}>Welcome to Omni Trade Beacon</h1>
                <p style={{ fontSize: '1.2em', color: '#b0b0b0' }}>Your Ultimate Guide to Top Trading Platforms</p>
            </header>

            <section style={{ marginBottom: '20px' }}>
                <h2 style={{ fontSize: '2em', color: '#e0e0e0' }}>About Us</h2>
                <p style={{ fontSize: '1.1em', color: '#b0b0b0' }}>
                    At Omni Trade Beacon, we provide an in-depth overview of the top platforms for trading stocks and cryptocurrencies. Our mission is to help you navigate the world of trading by showcasing the best platforms based on their features, user experience, and reliability.
                </p>
                <p style={{ fontSize: '1.1em', color: '#b0b0b0' }}>
                    Our curated list highlights platforms that excel in various aspects, from user-friendly interfaces and educational resources to advanced trading tools and low fees. Explore our selections to find the ideal trading platform that meets your needs.
                </p>
            </section>

            <section ref={sectionRef} style={{ marginBottom: '20px',textAlign: 'center' }}>
                <h2 style={{ fontSize: '2em', color: '#e0e0e0' }}>Top Trading Platforms</h2>
                <p style={{ fontSize: '1.1em', color: '#b0b0b0' }}>Discover why these platforms stand out in the world of stocks and cryptocurrencies:</p>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
                    {platforms.map(platform => (
                        <div key={platform.name} className={`platform-card ${inView ? 'fade-in' : ''}`} style={{ flex: '1 1 45%', backgroundColor: '#1e1e1e', padding: '20px', borderRadius: '8px', boxShadow: '0 0 10px rgba(0,0,0,0.5)' }}>
                            <h3 style={{ fontSize: '1.5em', color: '#e0e0e0' }}>{platform.name}</h3>
                            <p style={{ fontSize: '1.1em', color: '#b0b0b0' }}>{platform.reason}</p>
                            {platform.topAsset && <p style={{ fontSize: '1.1em', color: '#b0b0b0' }}>Top Asset: {platform.topAsset.topAsset}</p>}
                            <a href={platform.website} target="_blank" rel="noopener noreferrer" style={{ color: '#1e90ff', textDecoration: 'none', fontSize: '1.1em' }}>Visit Website</a>
                        </div>
                    ))}
                </div>
                <h2 style={{ fontSize: '2em', color: '#e0e0e0' }}>Explore More</h2>
                <p style={{ fontSize: '1.1em', color: '#b0b0b0' }}>
                    Learn more about different aspects of trading and get further insights:
                </p>
                <ul style={{ 
                    fontSize: '1.1em', 
                    color: '#b0b0b0', 
                    listStyleType: 'none', 
                    padding: '0', 
                    margin: '0', 
                    display: 'inline-block', 
                }}>
                    <li style={{ margin: '10px 0' }}>
                        <Link to="/trading-types" style={{ color: '#1e90ff', textDecoration: 'none' }}>
                            Discover various trading types and their benefits
                        </Link>
                    </li>
                    <li style={{ margin: '10px 0' }}>
                        <Link to="/faqs" style={{ color: '#1e90ff', textDecoration: 'none' }}>
                            Read our frequently asked questions for more information
                        </Link>
                    </li>
                    <li style={{ margin: '10px 0' }}>
                        <Link to="/about" style={{ color: '#1e90ff', textDecoration: 'none' }}>
                            Find out more about us and our mission
                        </Link>
                    </li>
                </ul>
            </section>

            <footer style={{ textAlign: 'center', padding: '10px 0', borderTop: '1px solid #333' }}>
                <p style={{ fontSize: '1em', color: '#b0b0b0' }}>&copy; 2024 Omni Trade Beacon. All rights reserved.</p>
            </footer>
        </div>
    );
}

export default Home;
